import React from 'react';
import PropTypes from 'prop-types';
import '../../YsDialog/YsDialog.scss';
import DialogContainer from './DialogContainer'

class ConfirmDialog extends React.Component {
    render() {
        const {
            confirmLabel = '确定',
            cancelLabel = '取消',
            show,
            title,
            content,
            confirm,
            dismiss,
            cancel,
        } = this.props;
        return (
            <section className={show ? 'dis-show' : 'dis-hide'}>
                <div className="dialog">
                    {/*<header className="dialog-header">{title}</header>*/}
                    <div className="dialog-body">
                        <div className="dialog-main">
                            <p dangerouslySetInnerHTML={{__html: content}}>
                            </p>
                        </div>
                    </div>
                    <div className="dialog-operate">
                        <button className="cancel"
                                onClick={() => cancel()}>{cancelLabel}</button>
                        <button className="confirm"
                                onClick={() => confirm()}>{confirmLabel}</button>
                    </div>
                </div>
                <div className="dialog-mask" onClick={() => cancel()}></div>
            </section>
        )
    }
}

ConfirmDialog.propTypes = {
    confirmLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    title: PropTypes.string,
    show: PropTypes.boolean,
    content: PropTypes.string,
    confirm: PropTypes.func,     // called when ok button is clicked.
    cancel: PropTypes.func,      // called when cancel button is clicked.
    dismiss: PropTypes.func,     // called when backdrop is clicked or escaped.
}

export default DialogContainer(ConfirmDialog);


// WEBPACK FOOTER //
// ./src/components/yunshl/Dialog/ConfirmDialog.js